import { useEffect, useMemo, useState } from "react"
import { INewReplenishmentResponse } from "interfaces/IReplenishment"
import { useNavigate } from "react-router"
import { InfoText, StrongText, ConversionInfoText } from "./styles"
import { Box, debounce, MenuItem, Select, Typography, CircularProgress } from "@mui/material"
import { toast } from "react-toastify"
import { replenishmentService } from "services/replenishmentService"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import { configsService } from "services/configsService"
import { IConfigDataResponse } from "interfaces/IConfig"
import { productService } from "services/productService"
import { IProductData, IProductResponse } from "interfaces/IProduct"
import { batchService } from "services/batchService"
import Cam from "utils/Cam"

const SplitBoxReplenishing = () => {
  const [successFeedback, setSuccessFeedback] = useState(false)
  const [isLoading, setisLoading] = useState(false)
  const [isConfigLoading, setIsConfigLoading] = useState(true)
  const [marketMigrate, setMarketMigrate] = useState<number | null>(null)
  const [marketReceiving, setMarketReceiving] = useState<number | null>(null)
  const [config, setConfig] = useState<IConfigDataResponse>({
    id: 0,
    created: "",
    totalMarkets: 0,
    modifiedById: 0,
    modifiedByUsername: "",
    useScanner: false,
  })
  const [products, setProducts] = useState<IProductResponse>({
    page: 0,
    page_size: 0,
    results: [],
    total_items: 0,
    total_pages: 0,
  })
  const [productsByProductBaseId, setProductsByProductbaseId] = useState<IProductResponse>({
    page: 0,
    page_size: 0,
    results: [],
    total_items: 0,
    total_pages: 0,
  })
  const [inputQuantityMigrateValue, setInputQuantityMigrateValue] = useState("")
  const [inputMigrateSkuValue, setInputMigrateSkuValue] = useState("")
  const [inputReplenishSkuValue, setInputReplenishSkuValue] = useState("")
  const [isDropdownMigrateSkuVisible, setIsDropdownMigrateSkuVisible] = useState(false)
  const [isDropdownReplenishSkuVisible, setIsDropdownReplenishSkuVisible] = useState(false)
  const [selectedMigrateSku, setSelectedMigrateSku] = useState<IProductData | null>(null)
  const [selectetReplenishSku, setSelectedReplenishSku] = useState<IProductData | null>(null)
  const [filterMigratSkuText, setFilterMigrateSkuText] = useState("")
  const [filterReplenishSkuText, setFilterReplenishSkuText] = useState("")
  const [convertionValue, setConvertionValue] = useState(0)
  const [showScanner, setShowScanner] = useState(true)
  const [batchId, setBatchId] = useState<number>(0)
  const [isLoadingBatches, setIsLoadingBatches] = useState(false)
  const [batches, setBatches] = useState<number[]>([])
  const [selectedBatch, setSelectedBatch] = useState<number>(0)
  const disableConfirmBotton =
    !inputQuantityMigrateValue ||
    !inputMigrateSkuValue ||
    !inputReplenishSkuValue ||
    !marketReceiving ||
    !marketMigrate ||
    isLoading ||
    convertionValue < 1 ||
    !Number.isInteger(convertionValue) ||
    Number(inputQuantityMigrateValue) < 1 ||
    isNaN(Number(inputQuantityMigrateValue)) ||
    (!config.useScanner && !selectedBatch)

  const navigate = useNavigate()

  const handleInputMigrateSkuChange = (event: any) => {
    setInputMigrateSkuValue(event.target.value)
    debouncedSearch(event.target.value)
  }

  const handleInputReplenishSkuChange = (event: any) => {
    setInputReplenishSkuValue(event.target.value)
    debouncedSearch(event.target.value)
  }

  const handleInputQuantityChange = (event: any) => {
    setInputQuantityMigrateValue(event.target.value)
  }

  const handleMigrateMarketNumberChange = (event: any) => {
    setMarketMigrate(Number(event.target.value))
  }

  const handleReceivingMarketNumberChange = (event: any) => {
    setMarketReceiving(Number(event.target.value))
  }

  const handleCreateReplenishment = async () => {
    try {
      setisLoading(true)
      const data = {
        productIdMigrate: selectedMigrateSku?.productId,
        quantityMigrate: Number(inputQuantityMigrateValue),
        marketNumberTakenFrom: marketMigrate,
        productIdReceived: selectetReplenishSku?.productId,
        marketNumberTakenTo: marketReceiving,
        quantityReceived: convertionValue,
        batchId: Number(batchId),
      }
      await replenishmentService.migrateSkuReplenishment(data)
      setSuccessFeedback(true)
    } catch (error: any) {
      toast(error?.message ?? "Ocorreu um erro, dá um alô pro time de tech.", { type: "error" })
    } finally {
      setisLoading(false)
    }
  }

  const handleGetConfigs = async () => {
    try {
      setIsConfigLoading(true)
      const response_config = await configsService.getConfig()
      setConfig(response_config)
    } catch (error: any) {
      toast(
        error?.message ?? "Ocorreu um erro ao buscar as configurações, dá um alô pro time de tech.",
        { type: "error" },
      )
    } finally {
      setIsConfigLoading(false)
    }
  }

  const handleGetProducts = async () => {
    try {
      setisLoading(true)
      const response_products = await productService.getProducts({
        orderBy: "name",
        status: "active",
      })
      setProducts(response_products)
    } catch (error: any) {
      toast(error?.message ?? "Ocorreu um erro ao buscar skus, dá um alô pro time de tech.", {
        type: "error",
      })
    } finally {
      setisLoading(false)
    }
  }

  const handleGetProductsByProductBaseId = async (productBaseId: number) => {
    try {
      setisLoading(true)
      const response_products = await productService.getProducts({
        orderBy: "name",
        status: "active",
        productBaseId,
      })
      setProductsByProductbaseId(response_products)
    } catch (error: any) {
      toast(error?.message ?? "Ocorreu um erro ao buscar skus, dá um alô pro time de tech.", {
        type: "error",
      })
    } finally {
      setisLoading(false)
    }
  }

  const handleNewReplenish = () => {
    setisLoading(true)
    setSuccessFeedback(false)
    navigate("/painel-de-operador/abastecimento")
    setisLoading(false)
  }

  const handleMigrateSkuFocus = () => {
    setIsDropdownMigrateSkuVisible(true)
    setInputMigrateSkuValue("")
    setFilterMigrateSkuText("")
    setSelectedMigrateSku(null)
    setInputReplenishSkuValue("")
    setFilterReplenishSkuText("")
    setSelectedReplenishSku(null)
  }

  const handleReplenishSkuFocus = () => {
    setIsDropdownReplenishSkuVisible(true)
    setInputReplenishSkuValue("")
    setFilterReplenishSkuText("")
    setSelectedReplenishSku(null)
  }

  const handleSelectMigrateProduct = async (product: IProductData) => {
    setSelectedMigrateSku(product)
    setFilterMigrateSkuText(product.name)
    setInputMigrateSkuValue(product.name)
    setIsDropdownMigrateSkuVisible(false)
    handleGetProductsByProductBaseId(product.productBaseId)
    setIsLoadingBatches(true)
    try {
      const response = await batchService.getAllBaseProducts({
        productBaseId: product.productBaseId,
      })
      const batchIds = response.results[0]?.Batchs?.map(batch => batch.batchId) || []
      setBatches(batchIds)
    } catch (error: any) {
      toast(error?.message ?? "Ocorreu um erro ao buscar os lotes, dá um alô pro time de tech.", {
        type: "error",
      })
    } finally {
      setIsLoadingBatches(false)
    }
  }

  const handleSelectReplenishProduct = (product: IProductData) => {
    setSelectedReplenishSku(product)
    setFilterReplenishSkuText(product.name)
    setInputReplenishSkuValue(product.name)
    setIsDropdownReplenishSkuVisible(false)
  }

  const handleScanResult = async (code: string) => {
    try {
      setisLoading(true)
      const response = await productService.checkBatch(code, "")
      if (response.skuData) {
        setSelectedMigrateSku(response.skuData)
        setFilterMigrateSkuText(response.skuData.name)
        setInputMigrateSkuValue(response.skuData.name)
        setBatchId(Number(response.batch_id))
        handleGetProductsByProductBaseId(response.skuData.productBaseId)
        setShowScanner(false)
      } else {
        toast("SKU não encontrado", { type: "error" })
      }
    } catch (error: any) {
      toast(error?.message ?? "Ocorreu um erro ao buscar o SKU, dá um alô pro time de tech.", {
        type: "error",
      })
    } finally {
      setisLoading(false)
    }
  }

  const handleScanAgain = () => {
    setShowScanner(true)
    setSelectedMigrateSku(null)
    setFilterMigrateSkuText("")
    setInputMigrateSkuValue("")
    setInputReplenishSkuValue("")
    setFilterReplenishSkuText("")
    setSelectedReplenishSku(null)
    setBatchId(0)
  }

  const generateNumberList = useMemo(() => {
    return config.totalMarkets > 0
      ? Array.from({ length: config.totalMarkets }, (_, i) => i + 1)
      : []
  }, [config.totalMarkets])

  const filteredMarketList = useMemo(() => {
    return generateNumberList.filter(number => number !== marketMigrate)
  }, [generateNumberList, marketMigrate])

  const handleGetProductDebounce = async (skuFiltered: string) => {
    try {
      setisLoading(true)
      const response_products = await productService.getProducts({
        orderBy: "name",
        status: "active",
        skuName: skuFiltered,
        pageSize: 1000,
      })
      setProducts(response_products)
    } catch (error: any) {
      toast(error?.message ?? "Ocorreu um erro ao buscar skus, dá um alô pro time de tech.", {
        type: "error",
      })
    } finally {
      setisLoading(false)
    }
  }

  const debouncedSearch = useMemo(
    () =>
      debounce((searchTerm: string) => {
        handleGetProductDebounce(searchTerm)
      }, 1000),
    [],
  )

  const handleBatchChange = (event: any) => {
    setSelectedBatch(Number(event.target.value))
    setBatchId(Number(event.target.value))
  }

  useEffect(() => {
    handleGetConfigs()
    handleGetProducts()
  }, [])

  useEffect(() => {
    const convertion =
      ((selectedMigrateSku?.purchaseValue || 0) * Number(inputQuantityMigrateValue || 0)) /
      (Number(selectetReplenishSku?.purchaseValue) || 1)
    console.log(convertion)
    setConvertionValue(convertion)
  }, [selectetReplenishSku, inputQuantityMigrateValue, selectedMigrateSku])
  return (
    <Box>
      {successFeedback ? (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          marginTop="50px"
        >
          <CheckCircleIcon sx={{ fontSize: 100, color: "#FF8C42" }} />
          <Typography
            style={{
              fontFamily: "Inter, sans-serif",
              fontWeight: "500",
              fontSize: "21px",
              lineHeight: "33.6px",
              letterSpacing: "1%",
              marginTop: "20px",
            }}
          >
            Produto migrado! 👍
          </Typography>
          <button
            onClick={handleNewReplenish}
            disabled={isLoading}
            style={{
              marginTop: "40px",
              padding: "10px 20px",
              fontSize: "18px",
              backgroundColor: "#FF8C42",
              color: "white",
              border: "none",
              borderRadius: "16px",
              cursor: "pointer",
              width: "300px",
            }}
          >
            beleza, valeu!
          </button>
        </Box>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {isConfigLoading ? (
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              marginTop="50px"
            >
              <CircularProgress sx={{ color: "#FF8C42" }} />
              <Typography
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: "500",
                  fontSize: "21px",
                  lineHeight: "33.6px",
                  letterSpacing: "1%",
                  marginTop: "20px",
                }}
              >
                Carregando configurações...
              </Typography>
            </Box>
          ) : (
            <>
              {config.useScanner && (
                <Box
                  style={{
                    width: "100%",
                    padding: "20px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                    marginBottom: "20px",
                  }}
                >
                  <Box>
                    <InfoText>
                      Produto:{" "}
                      <StrongText>{selectedMigrateSku?.name || "Ainda não definido"}</StrongText>
                    </InfoText>
                    <InfoText>
                      Porcionamento:{" "}
                      <StrongText>
                        {selectedMigrateSku?.purchaseValue}{" "}
                        {selectedMigrateSku?.portionType === "peso"
                          ? "kg"
                          : selectedMigrateSku?.portionType === "unidade"
                            ? "un"
                            : "Ainda não definido"}
                      </StrongText>
                    </InfoText>
                    <InfoText>
                      Etapa:{" "}
                      <StrongText>
                        {selectedMigrateSku?.separationOrder || "Ainda não definido"}
                      </StrongText>
                    </InfoText>
                    <InfoText>
                      Lote: <StrongText>{batchId || "Ainda não definido"}</StrongText>
                    </InfoText>
                  </Box>
                </Box>
              )}
              <Typography
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: "500",
                  fontSize: "27px",
                  lineHeight: "33.6px",
                  letterSpacing: "1%",
                  marginBottom: "1rem",
                }}
              >
                Migração de sku
              </Typography>
              {config.useScanner && showScanner ? (
                <div style={{ marginBottom: "20px", textAlign: "center" }}>
                  <Typography
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: "500",
                      fontSize: "20px",
                      lineHeight: "33.6px",
                      letterSpacing: "1%",
                      marginBottom: "1rem",
                    }}
                  >
                    Escaneie o código QR do SKU
                  </Typography>
                  <Cam onSubmit={handleScanResult} loading={isLoading} />
                </div>
              ) : (
                <>
                  {config.useScanner && selectedMigrateSku && (
                    <div style={{ marginBottom: "20px", textAlign: "center" }}>
                      <button
                        onClick={handleScanAgain}
                        style={{
                          padding: "8px 16px",
                          fontSize: "16px",
                          backgroundColor: "#FF8C42",
                          color: "white",
                          border: "none",
                          borderRadius: "12px",
                          cursor: "pointer",
                          width: "200px",
                        }}
                      >
                        Escanear novamente
                      </button>
                    </div>
                  )}
                  {!config.useScanner && (
                    <div style={{ marginBottom: "20px", textAlign: "center" }}>
                      <label
                        htmlFor="productSearch"
                        style={{
                          display: "block",
                          fontSize: "18px",
                          fontWeight: "500",
                          marginBottom: "8px",
                        }}
                      >
                        <Typography
                          style={{
                            fontFamily: "Inter, sans-serif",
                            fontWeight: "500",
                            fontSize: "20px",
                            lineHeight: "33.6px",
                            letterSpacing: "1%",
                          }}
                        >
                          Vai migrar qual sku?
                        </Typography>
                      </label>
                      <input
                        id="productSearch"
                        type="text"
                        value={inputMigrateSkuValue}
                        onChange={handleInputMigrateSkuChange}
                        onFocus={handleMigrateSkuFocus}
                        placeholder="Digite o nome e selecione"
                        disabled={isLoading}
                        style={{
                          padding: "8px",
                          fontSize: "18px",
                          width: "260px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                          textAlign: "center",
                        }}
                      />
                      {isDropdownMigrateSkuVisible && (
                        <ul
                          style={{
                            marginTop: "5px",
                            padding: "0",
                            listStyleType: "none",
                            width: "260px",
                            maxHeight: "150px",
                            overflowY: "auto",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            position: "absolute",
                            backgroundColor: "white",
                            zIndex: 1,
                          }}
                        >
                          {products.results.map(product => (
                            <li
                              key={product.productId}
                              onClick={() => handleSelectMigrateProduct(product)}
                              style={{
                                padding: "8px",
                                cursor: "pointer",
                              }}
                            >
                              {product.name}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}
                  {!config.useScanner && selectedMigrateSku && (
                    <div style={{ marginBottom: "20px", textAlign: "center" }}>
                      <label
                        htmlFor="batchSelect"
                        style={{
                          display: "block",
                          fontSize: "18px",
                          fontWeight: "500",
                          marginBottom: "8px",
                        }}
                      >
                        <Typography
                          style={{
                            fontFamily: "Inter, sans-serif",
                            fontWeight: "500",
                            fontSize: "20px",
                            lineHeight: "33.6px",
                            letterSpacing: "1%",
                          }}
                        >
                          Qual o lote?
                        </Typography>
                      </label>
                      {isLoadingBatches ? (
                        <CircularProgress sx={{ color: "#FF8C42" }} />
                      ) : (
                        <Select
                          id="batchSelect"
                          value={selectedBatch}
                          onChange={handleBatchChange}
                          disabled={isLoading}
                          displayEmpty
                          style={{
                            fontSize: "18px",
                            width: "260px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            textAlign: "center",
                            height: "2.5rem",
                          }}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 200,
                                overflowY: "auto",
                              },
                            },
                          }}
                          renderValue={selected => {
                            if (!selected) {
                              return "Selecione..."
                            }
                            return `Lote ${selected}`
                          }}
                        >
                          {batches.map(batch => (
                            <MenuItem key={batch} value={batch}>
                              Lote {batch}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    </div>
                  )}
                  <Typography
                    style={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: "500",
                      fontSize: "20px",
                      lineHeight: "33.6px",
                      letterSpacing: "1%",
                    }}
                  >
                    Quantos?
                  </Typography>

                  <input
                    type="number"
                    min="1"
                    value={inputQuantityMigrateValue}
                    onChange={handleInputQuantityChange}
                    style={{
                      padding: "8px",
                      fontSize: "18px",
                      width: "260px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      textAlign: "center",
                      marginTop: "0.5rem",
                      marginBottom: "0.5rem",
                    }}
                    placeholder="Ex. 40"
                  />
                  <div style={{ marginBottom: "20px", textAlign: "center" }}>
                    <label
                      htmlFor="migrateMarketNumber"
                      style={{
                        display: "block",
                        fontSize: "18px",
                        fontWeight: "500",
                        marginBottom: "0.5rem",
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: "Inter, sans-serif",
                          fontWeight: "500",
                          fontSize: "20px",
                          lineHeight: "33.6px",
                          letterSpacing: "1%",
                          marginTop: "0.5rem",
                        }}
                      >
                        Vai retirar de qual mercado?
                      </Typography>
                    </label>
                    <Select
                      id="migrateMarketNumber"
                      value={marketMigrate || ""}
                      onChange={handleMigrateMarketNumberChange}
                      disabled={isLoading}
                      displayEmpty
                      style={{
                        fontSize: "18px",
                        width: "260px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        textAlign: "center",
                        height: "2.5rem",
                      }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 200,
                            overflowY: "auto",
                          },
                        },
                      }}
                      renderValue={selected => {
                        if (!selected) {
                          return "Selecione..."
                        }
                        return `Mercado ${selected}`
                      }}
                    >
                      {generateNumberList.map(number => (
                        <MenuItem key={number} value={number}>
                          Mercado {number}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <Box style={{ marginBottom: "20px", textAlign: "center" }}>
                    <label
                      htmlFor="productSearch"
                      style={{
                        display: "block",
                        fontSize: "18px",
                        fontWeight: "500",
                        marginBottom: "8px",
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: "Inter, sans-serif",
                          fontWeight: "500",
                          fontSize: "20px",
                          lineHeight: "33.6px",
                          letterSpacing: "1%",
                        }}
                      >
                        Qual o sku de destino?
                      </Typography>
                    </label>
                    <input
                      id="productSearch"
                      type="text"
                      value={inputReplenishSkuValue}
                      onChange={handleInputReplenishSkuChange}
                      onFocus={handleReplenishSkuFocus}
                      placeholder="Digite o nome e selecione"
                      disabled={isLoading}
                      style={{
                        padding: "8px",
                        fontSize: "18px",
                        width: "260px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        textAlign: "center",
                      }}
                    />
                    {isDropdownReplenishSkuVisible && (
                      <ul
                        style={{
                          marginTop: "5px",
                          padding: "0",
                          listStyleType: "none",
                          width: "260px",
                          maxHeight: "150px",
                          overflowY: "auto",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          position: "absolute",
                          backgroundColor: "white",
                          zIndex: 1,
                        }}
                      >
                        {productsByProductBaseId.results
                          .filter(product => product.sku !== selectedMigrateSku?.sku)
                          .map(product => (
                            <li
                              key={product.productId}
                              onClick={() => handleSelectReplenishProduct(product)}
                              style={{
                                padding: "8px",
                                cursor: "pointer",
                              }}
                            >
                              {product.name}
                            </li>
                          ))}
                      </ul>
                    )}
                  </Box>
                  {selectedMigrateSku && inputQuantityMigrateValue && selectetReplenishSku && (
                    <ConversionInfoText conversionValue={convertionValue}>
                      <strong>
                        {convertionValue < 1
                          ? "Conversão deve ser maior que 1."
                          : !Number.isInteger(convertionValue)
                            ? "Conversão deve ser inteira."
                            : `Conversão: ${convertionValue} unidades.`}
                      </strong>
                    </ConversionInfoText>
                  )}
                  <div style={{ marginBottom: "20px", textAlign: "center" }}>
                    <label
                      htmlFor="receivingMarketNumber"
                      style={{
                        display: "block",
                        fontSize: "18px",
                        fontWeight: "500",
                        marginBottom: "0.5rem",
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: "Inter, sans-serif",
                          fontWeight: "500",
                          fontSize: "20px",
                          lineHeight: "33.6px",
                          letterSpacing: "1%",
                          marginTop: "0.5rem",
                        }}
                      >
                        Vai abastecer qual mercado?
                      </Typography>
                    </label>
                    <Select
                      id="receivingMarketNumber"
                      value={marketReceiving}
                      onChange={handleReceivingMarketNumberChange}
                      disabled={isLoading}
                      displayEmpty
                      style={{
                        fontSize: "18px",
                        width: "260px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        textAlign: "center",
                        height: "2.5rem",
                      }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 200,
                            overflowY: "auto",
                          },
                        },
                      }}
                      renderValue={selected => {
                        if (!selected) {
                          return "Selecione..."
                        }
                        return `Mercado ${selected}`
                      }}
                    >
                      {filteredMarketList.map(number => (
                        <MenuItem key={number} value={number}>
                          Mercado {number}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <button
                    disabled={disableConfirmBotton}
                    onClick={handleCreateReplenishment}
                    style={{
                      marginTop: "0.5rem",
                      padding: "10px 20px",
                      fontSize: "18px",
                      backgroundColor: disableConfirmBotton ? "#FFC78F" : "#FF8C42",
                      cursor: disableConfirmBotton ? "not-allowed" : "pointer",
                      color: "white",
                      border: "none",
                      borderRadius: "16px",
                      width: "300px",
                    }}
                  >
                    Migrar
                  </button>
                </>
              )}
            </>
          )}
        </div>
      )}
    </Box>
  )
}

export default SplitBoxReplenishing
